var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-primary",style:(("background-color: " + (_vm.getType(_vm.typeId).color)))},[_vm._v(" "+_vm._s(_vm.getType(_vm.typeId).name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }